import '.b4{position:relative;}.ssr-plugin'
import '.ce{max-width:28rem;}.ssr-plugin'
import Row from '@app/components/layout/Row'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'
import { styled, Style } from 'inlines'
import { Image } from '@app/components/core/image/Image'
import SteunpuntHeroImage from 'tenants/steunpunt-amsterdam/assets/images/landing/steunpunt-hero.jpg'
import { Tag } from '@app/components/core/tag/Tag'
import { faLocationDot, faKey } from '@fortawesome/pro-solid-svg-icons'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTranslations } from '@i18n/useLanguage'

const TagStyles = {
  paddingLeft: '0.25rem',
  paddingBlock: '0.25rem',
  '& > svg': {
    padding: '0.5rem',
    borderRadius: '50%',
    backgroundColor: 'var(--palette-white)',
  },
}

export const Hero = ({ style }: { style?: Style }) => {
  const isMobile = useMediaQuery()
  const t = useTranslations().app.steunpuntAmsterdam

  return (
    <Row
      gap="3rem"
      alignItems="center"
      style={{
        flexDirection: isMobile ? 'column' : 'row',
        ...style,
      }}
    >
      <Column>
        <Title.H1>{t.hero.title}</Title.H1>
        <Text.Large>{t.hero.subtitle}</Text.Large>
      </Column>

      <div className="b4 ce">
        <Tag
          variant="tertiary"
          label={t.hero.locationTag}
          iconLeft={faLocationDot}
          style={{
            ...TagStyles,
            position: 'absolute',
            right: isMobile ? '-0.5rem' : '-1.5rem',
            top: '-1rem',
          }}
        />
        <Image
          src={SteunpuntHeroImage}
          style={{ borderRadius: '1.25rem', width: '100%' }}
          alt={t.hero.title}
        />
        <Tag
          variant="tertiary"
          label={t.hero.categoryTag}
          iconLeft={faKey}
          style={{
            ...TagStyles,
            position: 'absolute',
            left: isMobile ? '-0.5rem' : '-4rem',
            bottom: '-0.75rem',
          }}
        />
      </div>
    </Row>
  )
}
